import { educationConstants } from "../constants";


const start = () => {
    return {type: educationConstants.START, payload: {loading: true}};
};

const stop = () => {
    return {type: educationConstants.STOP, payload: {loading: false}};
};

const list = (res) => {
    return {type: educationConstants.EDUCATION, payload: {list: res}};
};

const add = (res) => {
    return {type: educationConstants.ADD, payload: {add: res}};
};

const update = (res) => {
    return {type: educationConstants.UPDATE, payload: {update: res}};
};

const remove = (res) => {
    return {type: educationConstants.REMOVE, payload: {remove: res}};
};

const clear = () => {
    return {type: educationConstants.CLEAR, payload: {list: []}};
};

export const educationSelectors = {
    start,
    stop,
    list,
    add,
    update,
    remove,
    clear
}